const Output = require('./output');
const outputs = require('./outputs');

module.exports = {
    Output,
    outputs
};
